import React from 'react';
import styled, { keyframes } from 'styled-components';
import Highcharts from 'highcharts';
import { Chart } from '../Chart';
import { chartSettings } from './LineChart';
import { Box } from '../../Box/Box';
import { Shimmer } from '../../Shimmer/Shimmer';
import { Wrapper } from '../../Wrapper/Wrapper';
import { MarginProps } from '../../../../theme/styledProps';
import { theme } from '../../../../theme/theme';
import { CURVE } from '../charts.constants';

const loadingChartSettings: Highcharts.Options = {
  ...chartSettings,

  series: [
    {
      data: CURVE.map(y => [y]),
      type: 'spline',
    },
    {
      data: CURVE.map(y => [y - 1]),
      type: 'spline',
    },
  ],

  colors: [theme.colors.neutral['300'], theme.colors.neutral['300']],

  legend: {
    enabled: false,
  },

  tooltip: {
    enabled: false,
  },

  plotOptions: {
    ...chartSettings.plotOptions,

    series: {
      dashStyle: 'Dash',

      marker: {
        enabled: false,
      },

      states: {
        hover: { enabled: false },
      },
    },
  },
};

const dash = keyframes`
  to {
    stroke-dashoffset: 0;
    opacity: 0;
  }
`;

export const StyledChart = styled(Wrapper)`
  position: relative;
  height: calc(100% - 48px);
  max-width: 950px;

  .highcharts-series path {
    animation: ${dash} 3s ease infinite;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    opacity: 1;
  }
`;

interface LineChartLoadingProps extends MarginProps {
  chartHeight?: number;
  showLegend?: boolean;
}

export const LineChartLoading: React.FC<LineChartLoadingProps> = ({
  chartHeight = 260,
  showLegend = true,
}) => (
  <StyledChart>
    <Chart
      options={{
        ...loadingChartSettings,
        chart: {
          ...loadingChartSettings.chart,
          height: chartHeight,
        },
      }}
    />

    {showLegend && (
      <Box
        height={24}
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt="24"
      >
        <Shimmer height={24} width={120} mr="8" />
        <Shimmer height={24} width={120} ml="8" />
      </Box>
    )}
  </StyledChart>
);
